import { render, staticRenderFns } from "./companyDetails.html?vue&type=template&id=328ce00a&external"
import script from "./companyDetails.js?vue&type=script&lang=js&external"
export * from "./companyDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports